"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const react_redux_1 = require("react-redux");
const selectors_1 = require("~/store/selectors");
const redux_1 = require("redux");
const actions_1 = require("~/store/project/actions");
const utils_1 = require("~/utils/utils");
const consts_1 = require("~/store/account/consts");
const useClickOutsideHandler_1 = __importDefault(require("~/hooks/useClickOutsideHandler"));
const ProjectDetailsPopover_module_scss_1 = __importDefault(require("./ProjectDetailsPopover.module.scss"));
function ProjectDetailsPopover() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    const { t } = (0, react_i18next_1.useTranslation)('project');
    const showPopover = (0, react_redux_1.useSelector)(selectors_1.selectShowProjectDetailsPopover);
    const projectId = (0, react_redux_1.useSelector)(selectors_1.selectCurrentProjectId);
    const project = (0, react_redux_1.useSelector)(selectors_1.selectProject);
    const user = (0, react_redux_1.useSelector)(selectors_1.selectCurrentUser);
    const wrapperRef = (0, react_1.useRef)(null);
    const elementRef = (0, react_1.useRef)(null);
    const { dispatchToggleProjectDetailsPopover, dispatchGetProject } = (0, redux_1.bindActionCreators)({
        dispatchToggleProjectDetailsPopover: actions_1.toggleProjectDetailsPopover,
        dispatchGetProject: actions_1.getProject,
    }, (0, react_redux_1.useDispatch)());
    const hidePopover = () => dispatchToggleProjectDetailsPopover(false);
    (0, react_1.useEffect)(() => {
        if (projectId && showPopover) {
            dispatchGetProject(projectId);
        }
    }, [showPopover]);
    (0, useClickOutsideHandler_1.default)(wrapperRef, elementRef, hidePopover);
    return showPopover && project ? (react_1.default.createElement("div", { className: ProjectDetailsPopover_module_scss_1.default.container, ref: wrapperRef, "data-testid": "project-details-popover" },
        react_1.default.createElement("div", { ref: elementRef },
            react_1.default.createElement("div", { className: ProjectDetailsPopover_module_scss_1.default.label }, t('current-project')),
            react_1.default.createElement("div", null, project.name),
            react_1.default.createElement("div", { className: ProjectDetailsPopover_module_scss_1.default.label }, t('total-price')),
            react_1.default.createElement("div", null,
                "$", (_b = (_a = project.quotes) === null || _a === void 0 ? void 0 : _a.at(0)) === null || _b === void 0 ? void 0 :
                _b.total),
            react_1.default.createElement("div", { className: ProjectDetailsPopover_module_scss_1.default.label }, t('reference-number')),
            react_1.default.createElement("div", null,
                project.referenceNumber,
                ((_d = (_c = project.quotes) === null || _c === void 0 ? void 0 : _c.at(0)) === null || _d === void 0 ? void 0 : _d.revisionNumber) ? `-${project.quotes[0].revisionNumber}` : ''),
            (((_e = user === null || user === void 0 ? void 0 : user.userType) === null || _e === void 0 ? void 0 : _e.name) === consts_1.UserRoles.customer || ((_f = user === null || user === void 0 ? void 0 : user.userType) === null || _f === void 0 ? void 0 : _f.name) === consts_1.UserRoles.admin) &&
                project.distributor ? (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { className: ProjectDetailsPopover_module_scss_1.default.label }, t('distributor')),
                react_1.default.createElement("div", null, project.distributor.companyName))) : null,
            ((_g = user === null || user === void 0 ? void 0 : user.userType) === null || _g === void 0 ? void 0 : _g.name) === consts_1.UserRoles.distributor || ((_h = user === null || user === void 0 ? void 0 : user.userType) === null || _h === void 0 ? void 0 : _h.name) === consts_1.UserRoles.admin ? (react_1.default.createElement(react_1.default.Fragment, null,
                project.customer ? (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("div", { className: ProjectDetailsPopover_module_scss_1.default.label }, t('customer')),
                    react_1.default.createElement("div", null, (_j = project.customer) === null || _j === void 0 ? void 0 :
                        _j.firstName,
                        " ", (_k = project.customer) === null || _k === void 0 ? void 0 :
                        _k.lastName))) : null,
                react_1.default.createElement("div", { className: ProjectDetailsPopover_module_scss_1.default.label }, t('created-by')),
                react_1.default.createElement("div", null, (_l = project.user) === null || _l === void 0 ? void 0 :
                    _l.firstName,
                    " ", (_m = project.user) === null || _m === void 0 ? void 0 :
                    _m.lastName),
                react_1.default.createElement("div", { className: ProjectDetailsPopover_module_scss_1.default.label }, t('modified-by')),
                react_1.default.createElement("div", null, (_o = project.modifier) === null || _o === void 0 ? void 0 :
                    _o.firstName,
                    " ", (_p = project.modifier) === null || _p === void 0 ? void 0 :
                    _p.lastName))) : null,
            react_1.default.createElement("div", { className: ProjectDetailsPopover_module_scss_1.default.label }, t('last-modified')),
            react_1.default.createElement("div", null, (0, utils_1.formatTimeToRelative)(project.updatedAt)),
            react_1.default.createElement("div", { className: ProjectDetailsPopover_module_scss_1.default.label }, t('status')),
            react_1.default.createElement("span", { className: ProjectDetailsPopover_module_scss_1.default.status }, project.status)))) : null;
}
exports.default = ProjectDetailsPopover;
